import api from 'service/api'

const intermediadorAPI = api.create('intermediador', true)

const get = async ({ ...params }) => {
  return await intermediadorAPI.get('/accounts', { params })
}

const show = async (token) => {
  return await intermediadorAPI.get(`/accounts/${token}`)
}

const create = async ({ ...params }) => {
  return await intermediadorAPI.post('/accounts', params)
}

const getStats = async ({ ...params }) => {
  return await intermediadorAPI.get('/accounts/stats', { params })
}

const update = async ({ accountId = '', ...params }) => {
  return await intermediadorAPI.put(`/accounts/${accountId}`, params)
}

const approve = async (accountId) => {
  return await intermediadorAPI.put(`/accounts/${accountId}`, {
    status: 'approved',
  })
}

const refuse = async (accountId, reprovalReason) => {
  return await intermediadorAPI.put(`/accounts/${accountId}`, {
    status: 'refused',
    reproval_reason: reprovalReason,
  })
}

const accounts = {
  get,
  create,
  update,
  show,
  getStats,
  approve,
  refuse,
}

export default accounts
